// extracted by mini-css-extract-plugin
export default {"wrapper":"Locker_wrapper__1fo5q","icon_lock":"Locker_icon_lock__nPGbL","green":"Locker_green__iK0NE","icon_unlock":"Locker_icon_unlock__Q-IOu"};